// MF-67 — The most-used templates ("top reasons"), largest first, as horizontal bars coloured by
// type (tenant colours). Long template titles truncate on the axis (full title in the tooltip); counts are
// direct-labelled at the bar end.
import { useMemo } from 'react'
import ReactECharts from 'echarts-for-react'
import { FONT, INK, baseTextStyle, tooltipBase, fmtNumber, typeStyle } from './chartTheme'

const TopReasonsChart = ({ topTemplates = [], types = { byCode: new Map() }, labelWidth = 240 }) => {
  const rows = topTemplates
  const height = Math.max(160, rows.length * 34 + 24)
  const option = useMemo(
    () => ({
      textStyle: baseTextStyle,
      animationDuration: 400,
      grid: { top: 4, left: 8, right: 56, bottom: 4, containLabel: true },
      tooltip: {
        ...tooltipBase,
        trigger: 'item',
        formatter: ({ dataIndex }) => {
          const r = rows[dataIndex]
          return `${r.title}<br/><b>${fmtNumber(r.count)}</b> entries · ${typeStyle(r.type, types.byCode).label}`
        }
      },
      xAxis: {
        type: 'value',
        minInterval: 1,
        splitLine: { lineStyle: { color: INK.grid } },
        axisLabel: { color: INK.secondary, fontFamily: FONT, fontSize: 11 }
      },
      yAxis: {
        type: 'category',
        inverse: true,
        data: rows.map((r) => r.title),
        axisLine: { lineStyle: { color: INK.axis } },
        axisTick: { show: false },
        axisLabel: {
          color: INK.primary,
          fontFamily: FONT,
          fontSize: 12,
          width: labelWidth,
          overflow: 'truncate'
        }
      },
      series: [
        {
          type: 'bar',
          barMaxWidth: 18,
          data: rows.map((r) => ({
            value: r.count,
            itemStyle: {
              color: typeStyle(r.type, types.byCode).color,
              borderRadius: [0, 4, 4, 0]
            }
          })),
          label: {
            show: true,
            position: 'right',
            formatter: ({ value }) => fmtNumber(value),
            color: INK.primary,
            fontFamily: FONT,
            fontSize: 11
          }
        }
      ]
    }),
    [rows, labelWidth, types]
  )

  return (
    <ReactECharts option={option} notMerge style={{ height, width: '100%' }} opts={{ renderer: 'svg' }} />
  )
}

export default TopReasonsChart
